enum ModalsActionTypesEnum {
  SHOW_MODAL = 'SHOW_MODAL',
  HIDE_MODAL = 'HIDE_MODAL',
}

export default ModalsActionTypesEnum;
